import {Text} from '@rdcomponents/text/text';
import {Card, Skeleton} from 'antd';

import {useCatalogInfo} from '../../../../../../provider/catalogs/catalogs-hook';
import {RatingDynamicsCompaniesStatsDataType} from '../../../../../../service/reivew-analysis/rating-dynamics/reviews-analytics-ratings-dynamic-type';

import * as styles from './rating-history-average-rating-card.scss';

type PropsType =
    | {
          catalogRatingData: Exclude<
              RatingDynamicsCompaniesStatsDataType['ratingsAverage']['catalogAverages'],
              null | undefined
          >[number];
          loading?: never;
      }
    | {
          loading: true;
          catalogRatingData?: never;
      };

export function RatingHistoryAverageCatalogRatingCard(props: PropsType): JSX.Element {
    const {catalogRatingData} = props;

    const {getCatalogName} = useCatalogInfo();

    return (
        <Card>
            <div className={styles.RatingHistoryAverageRating}>
                {catalogRatingData ? (
                    <>
                        <Text
                            block
                            secondary
                            small
                            stringKey="REVIEWS_ANALYSIS__RATINGS_DYNAMICS__CATALOG_AVERAGE_RATING"
                            valueMap={{
                                catalogName: (
                                    <Text bolder small>
                                        {getCatalogName(catalogRatingData.catalog)}
                                    </Text>
                                ),
                            }}
                        />
                        <Text block bolder className={styles.RatingHistoryAverageRating_value}>
                            {catalogRatingData.target}
                        </Text>
                    </>
                ) : (
                    <>
                        <Text
                            block
                            secondary
                            small
                            stringKey="REVIEWS_ANALYSIS__RATINGS_DYNAMICS__CATALOG_AVERAGE_RATING"
                            valueMap={{
                                catalogName: <Skeleton.Input active size="small" />,
                            }}
                        />
                        <Skeleton.Input active size="large" />
                    </>
                )}
            </div>
        </Card>
    );
}
